import { createStore } from 'zustand/vanilla'
import { useStore } from 'zustand'
import type { UserAndOrganizationStore } from '../types/userAndOrganization'
import { Organization } from '../types'

export const vanillaUserAndOrganizationStore = createStore<UserAndOrganizationStore>((set) => ({
  currentUser: {},
  setCurrentUser: (user) => set((state) => ({ ...state, currentUser: user })),
  currentOrganization: {} as Organization,
  setCurrentOrganization: (organization) =>
    set((state) => ({ ...state, currentOrganization: organization as Organization })),
  isAuthenticated: false,
  setIsAuthenticated: (isAuthenticated) => set((state) => ({ ...state, isAuthenticated }))
}))

// for performance: https://github.com/pmndrs/zustand#memoizing-selectors
const userSelector = (
  state: UserAndOrganizationStore
): Pick<UserAndOrganizationStore, 'currentUser' | 'setCurrentUser'> => ({
  currentUser: state.currentUser,
  setCurrentUser: state.setCurrentUser
})

export const useCurrentUser = () => useStore(vanillaUserAndOrganizationStore, userSelector)

const organizationSelector = (
  state: UserAndOrganizationStore
): Pick<UserAndOrganizationStore, 'currentOrganization' | 'setCurrentOrganization'> => ({
  currentOrganization: state.currentOrganization,
  setCurrentOrganization: state.setCurrentOrganization
})
export const useCurrentOrganization = () =>
  useStore(vanillaUserAndOrganizationStore, organizationSelector)

const isAuthenticatedSelector = (
  state: UserAndOrganizationStore
): Pick<UserAndOrganizationStore, 'isAuthenticated' | 'setIsAuthenticated'> => ({
  isAuthenticated: state.isAuthenticated,
  setIsAuthenticated: state.setIsAuthenticated
})

export const useIsAuthenticated = () =>
  useStore(vanillaUserAndOrganizationStore, isAuthenticatedSelector)

export const useContrastState = <R>(selector: (state: UserAndOrganizationStore) => R) =>
  useStore(vanillaUserAndOrganizationStore, selector)
